import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Cookies from 'js-cookie'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/global.scss'
import fontawesome from '@fortawesome/fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import SensitiveWordsService from './utils/sensitiveWords'
import VueMeta from 'vue-meta' // 1. 引入 vue-meta

Vue.use(VueMeta, {
  // 可选配置：自定义属性名，默认是 `metaInfo`
  keyName: 'metaInfo',
  // 刷新组件标签的属性 (防止组件复用时的旧数据残留)
  attribute: 'data-vue-meta',
  // 将 meta 标签的 `vmid` 属性命名为 `key`
  ssrAttribute: 'data-vue-meta-server-rendered',
  // 组件中 meta 标签的标签类型
  tagIDKeyName: 'vmid'
})
// 添加图标到库
library.add(fas);

import i18n from '@/lang';
import AMap from 'vue-amap';
Vue.use(AMap);
// 初始化vue-amap
AMap.initAMapApiLoader({
  // 申请的高德key
  key: 'YOUR_KEY',
  // 插件集合
  plugin: ['']
});
Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})
Vue.config.productionTip = false
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.prototype.$globalApiAddress = process.env.VUE_APP_BASE_API
Vue.prototype.$globalUploadArr = process.env.VUE_APP_BASE_API + "/uploads/"

//  // 页面加载时自动加载默认词库
// document.addEventListener('DOMContentLoaded', async function() {
//   if (!SensitiveWordsService.isLoaded) {
//     await SensitiveWordsService.loadWords()
//   }
// });

// document.addEventListener('input', async (event) => {
//   const target = event.target
//   if (SensitiveWordsService.isInputElement(target)) {
//     await SensitiveWordsService.CheckSensitiveWords(target.value)
//   }
// }, true)


// 禁止右键菜单
document.oncontextmenu = function () { return false; };
// 禁止文字选择
document.onselectstart = function () { return false; };
// 禁止复制
document.oncopy = function () { return false; };
// 禁止剪切
document.oncut = function () { return false; };
// 注册全局指令
Vue.directive('fade-in', {
  inserted: function (el, binding) {
    // 设置默认值
    const options = {
      threshold: binding.value?.threshold || 0.2,
      animation: binding.value?.animation || 'fade-in',
      delay: binding.value?.delay || 0
    };

    // 添加基础动画类
    el.classList.add(options.animation);

    // 创建 Intersection Observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 使用setTimeout实现延迟效果
          setTimeout(() => {
            entry.target.classList.add('active');
          }, options.delay);

          // 动画触发后停止观察
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: options.threshold
    });

    // 开始观察元素
    observer.observe(el);
  }
});
router.afterEach((to, from, next) => {
  document.querySelector("body").setAttribute("style", "overflow: auto !important;")
});
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app') 
